import { create, all } from 'mathjs'

const math = create(all, {})

export default math
